import React from "react";
import SportCode from "components/common/SportCode";
import { useUrlFriendlyToParameters } from "helpers/urlFriendly";

export function ScoreContainer(props) {
  const { resultObj, } = props;
  const { mirs_discipline } = useUrlFriendlyToParameters()
  const result = resultObj?.result;
  const boldWinner = resultObj?.rCn ? resultObj?.rCn : resultObj?.wlt === "W" ? ' fw-bold ' : '';
  return (
    <div className='score-result-container d-flex justify-content-end align-self-center'>
      <div className={`score-result ${boldWinner} p-0 text-end `}>
        {result}
      </div>
      <div className={`p-0 fw-bold text-end score-irm`} style={resultObj?.hasIRM ? { minWidth: '30px' } : {}}>
        <SportCode discipline={mirs_discipline} code={resultObj?.irm} entity="@IRM" abbr={true} />
      </div>
    </div >
  )
}

export default ScoreContainer